import React from "react";
import PropTypes from "prop-types";
import styles from "./ButtonStyledRadioButton.module.css";
import classNames from "classnames";

/**
 * Interactive component. A radio button styled as a button that allows a user to select an option.
 */
export function ButtonStyledRadioButton({
  isSelected,
  setCurrentlySelected,
  value,
  buttonContent,
}) {
  return (
    <div className={styles.container}>
      <label htmlFor={value}>
        <input
          type="radio"
          value={value}
          name={value}
          defaultChecked={isSelected}
          hidden
        />
        <button
          value={value}
          type="button"
          className={classNames(styles.button, {
            [styles.active]: isSelected,
          })}
          onClick={setCurrentlySelected}
        >
          <div className={styles.content}>{buttonContent}</div>
        </button>
      </label>
    </div>
  );
}

ButtonStyledRadioButton.propTypes = {
  /**
   * Boolean that determines if the option is selected.
   */
  isSelected: PropTypes.bool,
  /**
   * Function that sets the value of the currently selected option.
   * Use event.target.value to retrieve the value.
   */
  setCurrentlySelected: PropTypes.func,
  /**
   * The option value.
   */
  value: PropTypes.string,
  /**
   * The text/image content of the button.
   */
  buttonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};
